import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useEffect, useMemo } from 'react'
import { setParams } from '@ucheba/utils/helpers/analytics/ga'
import { useDispatch, useSelector } from 'react-redux'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import { eventsMyThunks } from '@ucheba/store/events/my'
import { plannerPlanThunks } from '@ucheba/store/planner/plan'
import { authSelectors } from '@ucheba/store/auth'
import { feedbacksThunks } from '@ucheba/store/feedbacks'
import { questionsThunks } from '@ucheba/store/questions'
import { IUzPageProps } from '../../../../../components/LayoutInstitution/types'
import Custom404 from '../../../../404.page'
import { useUserActivity } from '../../../../../../utils/hooks/useUserActivity'
import Page from '../../../ssr/[id]/index/desktop'
import { useUzCanonical } from '../../../ssr/[id]/utils/useUzCanonical'

const InstitutionPage: NextPage<IUzPageProps> = (props) => {
  const { content, notFound } = props
  const currentInstitution = useSelector(institutionItemSelectors.currentInstitution)
  const isAuth = useSelector(authSelectors.isAuth)
  const dispatch = useDispatch()
  const { canonical } = useUzCanonical()

  const params = useMemo(() => {
    const obj: any = {}

    if (currentInstitution) {
      obj.dimension1 = currentInstitution.parent?.id || currentInstitution.id

      if (currentInstitution.parent?.id) {
        obj.dimension2 = currentInstitution.id
      }
    }

    return obj
  }, [currentInstitution])

  const { setUserActivity } = useUserActivity()

  useEffect(() => {
    const { href } = window.location

    if (currentInstitution) {
      if (isAuth) {
        dispatch<any>(eventsMyThunks.fetch({}))
        dispatch<any>(
          feedbacksThunks.fetch({
            data: { id: currentInstitution.id, type: 'institution', limit: 3 },
          })
        )
        dispatch<any>(
          questionsThunks.fetch({
            data: { id: currentInstitution.id, type: 'institution', limit: 3 },
          })
        )

        dispatch<any>(plannerPlanThunks.getProgramIds({}))
      }

      setUserActivity({
        activityType: EActivityTypes.viewing_institution_info,
        institutionId: currentInstitution.id,
        data: { url: href },
      })
    }
  }, [])

  setParams(params)

  if (notFound || !currentInstitution) {
    return <Custom404 />
  }

  return (
    <>
      <NextSeo
        title={content.seo.meta.title}
        description={content.seo.meta.description}
        additionalMetaTags={[
          {
            property: 'keywords',
            content: content.seo.meta.keywords,
          },
        ]}
        canonical={canonical}
      />

      <Page {...(props as any)} />
    </>
  )
}

export default InstitutionPage
